// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Um-z","tupacHeader":"Vm-z","tupacHeader2":"Wm-z","tupacMenu":"Xm-z","tupacMenu2":"Ym-z","tupacMain":"Zm-z","tupacMain2":"_m-z"};